import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StoreService } from '../../../providers/store.service';
import { PublicRecordsService } from '../../../providers/public-records.service';
import { Horse_show } from '../../../models/horse_show';
import { Store_category } from '../../../models/accounting/store/store_category';
import { Store_item } from '../../../models/accounting/store/store_item';
import { Store_order } from '../../../models/accounting/store/store_order';
import { Store_order_item } from '../../../models/accounting/store/store_order_item';
import { Braintree_transaction } from '../../../models/accounting/banking/braintree_transaction';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';

@Component({
  standalone: false,
  selector: 'app-storefront-receipt',
  templateUrl: './storefront-receipt.component.html',
styleUrls:  ['./storefront-receipt.component.css']
})
export class StorefrontReceiptComponent  extends SmsAbstractAppPage implements OnInit {

  category: Store_category = new Store_category({});
	horse_show: Horse_show = new Horse_show({});
	order: Store_order = new Store_order({});

  constructor(private route: ActivatedRoute, private storeService: StoreService, private publicRecordsService: PublicRecordsService) {
  	super();
  }

  ngOnInit() {

    this.route.params.subscribe(params => {

          if(params['order_id']){

            this.storeService.getOrder(params['order_id']).then(store_order => {
              this.order = store_order;

              this.publicRecordsService.getHorseShow(store_order.horse_show_id).then(horse_show => {
                this.horse_show = horse_show;
              });

              this.storeService.getCategory(store_order.horse_show_id, store_order.category_number).then(category => {
                this.category = category;
              }).catch(error => {
                this.handleError(error);
              });

            }).catch(error => {
              this.handleError(error);
            });

          } else {
            this.handleError("ORDER ID missing from request");
          }

     });

  }

}
